import axios from 'axios'
import { backendUrl } from '../../config/config'
import { async } from 'q'

const login = async (data) => {
  try {
    const response = await axios.post(`${backendUrl}/api/users/login/`, data)
    return response.data
  } catch (err) {
    console.log(err)
  }
}

const register = async (data) => {
  try {
    const response = await axios.post(`${backendUrl}/api/users/register/`, data)
    return response.data
  } catch (err) {
    console.log(err)
  }
}

const getUsers = async () => {
  const users = await axios.get(`${backendUrl}/api/users/getUsers/`)
  return users.data
}

const getUserByEmail = async (email) => {
  const user = await axios.get(`${backendUrl}/api/users/getUsers/${email}`)
  return user.data
}

const newUser = async (email,password, role, team) => {
  const result = await axios.post(`${backendUrl}/api/users/newUser/`, {"email":email,"password":password,"role":role,"team":team})
  return result;
}

const deleteUser = async (email) => {
  const result = await axios.delete(`${backendUrl}/api/users/deleteUser/${email}`)
  return result;
}

const updateUser = async (email, password, oldPassword, role, team, enabled,securityQuestionID,securityAnswer) => {
  const result = await axios.put(`${backendUrl}/api/users/user/`, {"email":email,"password":password,"oldPassword":oldPassword,"role":role,"team":team,"enabled":enabled,"securityQuestionID":securityQuestionID,"securityAnswer":securityAnswer})
  return result;
}


const getSecurityQ = async (email) => {
  const securityQ = await axios.get(`${backendUrl}/api/users/securityQ/${email}`)
  return securityQ.data
}

const changePassword = async (email, response) => {
  console.log(email);
  const result = await axios.post(`${backendUrl}/api/users/changePassword`, {"email":email,"response":response})
  return result.data
}

export {
  login, 
  register,
  getUsers,
  getUserByEmail,
  newUser,
  deleteUser,
  updateUser,
  getSecurityQ,
  changePassword
}
